module.exports = __webpack_public_path__ + "img/img22.0365811d.png";